import React from 'react';
import { FadeIn } from './FadeIn';
import { RouteLink } from '../lib/router';
import { SafeImage } from './SafeImage';
export function Hero() {
  return <section className="relative flex min-h-[82vh] flex-col justify-end overflow-hidden bg-charcoal px-6 pb-24 pt-24 md:min-h-[88vh] md:px-12" data-id="element-123" data-mp="ehtiju9l4xmr">
      <div className="absolute inset-0 z-0" data-id="element-124" data-mp="4m8ku8bjujit">
        <SafeImage src="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg" alt="Sauna at night with steam rising from the chimney" className="h-full w-full object-cover object-center" data-id="element-125" data-mp="4njq6ckn7zc1" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/30 mix-blend-multiply" data-id="element-126" data-mp="3d1a83izra9cr" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/50 to-transparent" data-id="element-127" data-mp="3825wymt9u1js" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl" data-id="element-128" data-mp="3j9k9t8cxxbej">
        <FadeIn delay={0.2} data-id="element-129" data-mp="3o7lvm11r3otp">
          <p className="mb-6 text-xs font-medium uppercase tracking-[0.2em] text-sand/80" data-id="element-130" data-mp="3o7vhbcfrj9tl">
            Near Pardes Hanna / Kfar Pines
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-131" data-mp="3e9fpt8ctpyjk">
          <h1 className="mb-8 font-serif text-5xl leading-[1.05] text-offwhite md:text-7xl lg:text-8xl" data-id="element-132" data-mp="3e8mssz3o2nem">
            Gather. Sweat.
            <br data-id="element-133" data-mp="30gq4z7916zo1" />
            Breathe. Reset.
          </h1>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-134" data-mp="359sy5e9wc73p">
          <p className="mb-12 max-w-2xl text-lg font-light leading-relaxed text-sand/90 md:text-xl" data-id="element-135" data-mp="35a2jupnwrs3l">
            A retreat space for deep rest, connection, sauna, cold water, music,
            and overnight stays.
          </p>
        </FadeIn>

        <FadeIn delay={0.8} className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-4" data-id="element-136" data-mp="2hinc2hdd4iky">
          <RouteLink to="/stay" className="inline-flex items-center justify-center rounded-sm bg-ember px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-ember/90" data-id="element-137" data-mp="2lla6mq1f4hlu">
            Stay overnight
          </RouteLink>
          <RouteLink to="/membership" className="inline-flex items-center justify-center rounded-sm border border-cream/30 bg-transparent px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-cream/10" data-id="element-138" data-mp="n9i3jbjbrctl">
            Pines Membership
          </RouteLink>
          <RouteLink to="/space" className="inline-flex items-center justify-center rounded-sm border border-cream/30 bg-transparent px-7 py-4 font-medium tracking-wide text-cream transition-colors hover:bg-cream/10" data-id="element-139" data-mp="161t0korasgjs">
            Retreat Space
          </RouteLink>
        </FadeIn>
      </div>
    </section>;
}